import moment from "moment-timezone";
import { RealtimeClient } from "../RealtimeClient";
import { RestClient } from "../restClient";

export class TimeConversion {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	convertToUserTime(time, format, locale) {
		let userTime = time;
		if (!locale) {
			locale = "en";
		}

		const [type, hourFormat] = format.split("_");
		if (type === "full") {
			if (hourFormat === "12-hour") {
				userTime = moment.tz(time, moment.tz.guess()).locale(locale).format("MM/DD/YYYY hh:mm A z");
			} else if (hourFormat === "24-hour") {
				userTime = moment.tz(time, moment.tz.guess()).locale(locale).format("MM/DD/YYYY HH:mm z");
			} else {
				userTime = `${moment.tz(time, moment.tz.guess()).locale(locale).format("MM/DD/YYYY hh:mm A z")}`;
			}
		} else if (type === "time") {
			if (hourFormat === "12-hour") {
				userTime = moment.tz(time, moment.tz.guess()).locale(locale).format("hh:mm A z");
			} else if (hourFormat === "24-hour") {
				userTime = moment.tz(time, moment.tz.guess()).locale(locale).format("HH:mm z");
			} else {
				userTime = `${moment.tz(time, moment.tz.guess()).locale(locale).format("hh:mm A z")}`;
			}
		} else {
			userTime = moment.tz(time, moment.tz.guess()).locale(locale).format(format);
		}

		return userTime;
	}
}
